<template lang="pug">
  .new-features
    v-container(style="max-width:600px")
      div.mt-2
        //- Empty
        v-row.fill-height(v-if="!isFetching && newFeatures.length === 0" align='center' justify='center')
          div.mx-auto
            v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
            p.caption {{ $t('new_features_not_found') }}
        //- List of cards
        div.mt-4(v-else)
          v-card.mt-4(v-for="(feature, featureIndex) in newFeatures" :key="feature.id" outlined style="border: 1px solid var(--v-basic400);" :class="featureIndex === newFeatures.length-1 ? 'mb-4' : ''")
            div.d-flex.flex-no-wrap.justify-space-between.align-center
              div
                v-card-title.s1.basic800--text.text-wrapper {{ feature.title }}
                v-card-subtitle.c1.basic600--text {{ feature.description }}
              v-avatar.ma-3(v-if="feature.image" size="125" rounded)
                v-img(:src="feature.image.file")
            v-divider.basic400
            v-card-actions.d-flex.justify-end.align-center.px-4.py-2
              v-btn.mr-2(text @click='openDetails(feature.id)' :class="`newfeatures-${feature.id}`")
                .button-Aa-small.info500--text {{ $t('learn_more') }}
              v-btn(v-if="member.role === 'Admin' && feature.feature_link" color="info500" small depressed :loading="feature.id === redirectId" @click='goTo(feature)')
                .button-AA-tiny.white--text {{ $t('try_it_now') }}
          //- Intersection
          v-divider.white(v-if="hasNext" style="border: 1px solid" v-intersect="infiniteScrolling")
          //- Loading
          v-row(v-if="isFetching" align='center' justify='center' :class="newFeatures.length === 0 ? 'fill-height' : 'mt-2'")
            v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
        .modals
          //- Details dialog
          y-dialog(v-if="openDetailsDialog" v-model='openDetailsDialog', :fullscreen="$vuetify.breakpoint.xsOnly" max-width="600px")
            v-card
              v-row.px-5.pt-3.pb-2(@click="openDetailsDialog = false" no-gutters align="center")
                v-btn.ml-n3(text icon)
                  eva-icon(name="chevron-left-outline" :fill="$vuetify.theme.themes[$theme].basic800" width="24" height="24")
                p.mb-0.c1.basic800--text.clickable {{ $t('back') }}
              //- Loading 
              v-row.fill-height.ma-0(v-if="isFetchingFeature" align='center' justify='center')
                v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
              //- Display content
              v-card-text.pa-0(v-else)
                div.display-content(v-html="selectedContent")
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'NewFeatures',
  data: () => ({
    isFetching: false,
    openDetailsDialog: false,
    newFeatures: [],
    selectedContent: null,
    isFetchingFeature:false,
    redirectId: null,
    page: 1,
    hasNext: true
  }),
  computed: {
    ...mapState('user', ['member'])
  },
  mounted () {
    this.fetchNewFeatures()
  },
  methods: {
    fetchNewFeatures() {
      if (this.isFetching || !this.hasNext) {
        return
      }
      this.isFetching = true
      const params = { page: this.page, language: this.$root.$i18n.locale }
      this.$axios.get('/news', { params })
        .then((response) => {
          this.newFeatures = this.newFeatures.concat(response.data.results)
          this.hasNext = response.data.next !== null
          if (this.page === 1) {
            this.updateLatestReadId()
          }
          this.page++
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    openDetails(featureId) {
      this.isFetchingFeature = true
      this.openDetailsDialog = true
      this.$axios.get(`/news/${featureId}`)
        .then((response) => {
          this.selectedContent = response.data.content
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetchingFeature = false
        })
    },
    goTo(feature) {
      this.redirectId = feature.id
      this.$router.push(feature.feature_link)
    },
    infiniteScrolling (entries, observer, isIntersecting) {
      if (isIntersecting) {
        this.fetchNewFeatures()
      }
    },
    updateLatestReadId() {
      const latestReadId = this.newFeatures[0].id
      localStorage.setItem('new_feature_last_read', latestReadId)
      this.$store.commit('ui/setHasNewFeature', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.fill-height {
  height: 75vh;
}
.display-content {
  overflow-x: hidden;
}
.text-wrapper {
  word-break: break-word;
}
</style>

<i18n>
{
  "en": {
    "learn_more": "Learn more",
    "try_it_now": "Try it now",
    "new_features_not_found": "New features not found or empty"
  },
  "id": {
    "learn_more": "Pelajari selengkapnya",
    "try_it_now": "Coba sekarang",
    "new_features_not_found": "Fitur baru tidak ditemukan"
  }
}
</i18n>